import { NgModule } from '@angular/core';
import { NcHtml2canvasService } from './html2canvas.service';

@NgModule({
    providers: [NcHtml2canvasService]
})
export class NcHtml2canvasServiceModule { }